<script>
  export default {
    props: {
      lat: {
        type: Number,
        required: true,
      },
      lng: {
        type: Number,
        required: true,
      },
      description: {
      	type: String,
        required: false,
      }
    },
    mounted() {
      this.$root.$emit('register-marker', this);
    },
    render() {
      return null;
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/maps/assets/js/components/RubinredMarker.vue